import { Card } from "antd";
import styled from "styled-components";

/**
 * SHADOW BOX CARD — Elevated card for desktop, transparent on mobile.
 *
 * Design decisions:
 * - Desktop: subtle shadow + border for depth, rounded corners
 * - Mobile: invisible card (no shadow, no border) — content fills the screen
 * - This BrowserView/MobileView pattern keeps mobile clean and spacious
 * - Border-radius 16px matches our design system --radius-lg
 */
const ResponsiveCard = styled(Card)`
  border-radius: var(--radius-lg);
  border: 1px solid var(--color-border);
  box-shadow: var(--shadow-md);
  background: var(--color-bg-elevated);
  transition: var(--transition-shadow);

  &:hover {
    box-shadow: var(--shadow-lg);
  }

  @media (max-width: 768px) {
    &.ant-card {
      box-shadow: none;
      border: none;
      background: transparent;
      border-radius: 0;
    }

    .ant-card-body {
      padding: 0;
    }
  }
`;

interface IProps {
  id?: string;
  children: any;
  className?: string;
  style?: React.CSSProperties;
  onClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
}

export const ShadowBoxCard: React.FC<IProps> = ({
  id,
  style,
  children,
  className,
  onClick,
}) => {
  return (
    <ResponsiveCard
      id={id}
      className={className}
      style={style}
      onClick={onClick}
    >
      {children}
    </ResponsiveCard>
  );
};
